/**
 * CMS Fetch Utilities for Bachmann Tømrer
 */

const API_BASE_URL = "https://api.dev.auxo.dk";

/**
 * Fetches a single entry by its localized slug (Danish 'da' is default)
 * @param {string} slug 
 * @param {string} lang 
 * @returns {Promise<Object>}
 */
export async function fetchBySlug(slug, lang = "da") {
  const response = await fetch(`${API_BASE_URL}/public/by-slug/${lang}/${slug}`);
  if (!response.ok) {
    throw new Error(`Kunne ikke hente indhold for slug: ${slug}`);
  }
  return response.json();
}

/**
 * Fetches an entire collection using the v2 paginated endpoint
 * @param {string} collectionName 
 * @param {Object} params 
 * @returns {Promise<Object>}
 */
export async function fetchCollectionV2(collectionName, params = {}) {
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, val]) => {
    if (val !== undefined && val !== null) {
      queryParams.append(key, val);
    }
  });
  
  const url = `${API_BASE_URL}/public/v2/content/${collectionName}${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Kunne ikke hente kollektion: ${collectionName}`);
  }
  return response.json();
}

/**
 * Fetches an entire collection as a bare array (v1)
 * @param {string} collectionName 
 * @returns {Promise<Array>}
 */
export async function fetchCollectionV1(collectionName) {
  const response = await fetch(`${API_BASE_URL}/public/content/${collectionName}`);
  if (!response.ok) {
    throw new Error(`Kunne ikke hente kollektion: ${collectionName}`);
  }
  return response.json();
}

/**
 * Helper to extract localized text or return a fallback
 * @param {Object|string} field 
 * @param {string} lang 
 * @returns {string}
 */
export function getLocalized(field, lang = "da") {
  if (!field) return "";
  if (typeof field === "string") return field;
  return field[lang] || field["da"] || Object.values(field)[0] || "";
}
